import React, { SetStateAction, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendCompany,
	RosterUserInfo,
} from "node-library/dist/portal";
import {
	OrderTableSortColumn,
	SortOrder,
	UserTableSortColumn,
} from "node-library/dist/paginations";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { Severity, UserStatus } from "node-library/dist/constants";
import {
	sendGETRequest,
	sendPOSTRequest,
} from "../../../requestHelper/sendRequest";
import { RedErrorIcon } from "../../../common-components/toast/errorIcons";
import {
	getUserSortString,
	getUserStatusString,
} from "../../../helpers/userHelper";
import {
	CustomRadioGroup,
	CustomSearchBar,
	RowDropdown,
} from "../../../common-components/inputs";
import {
	AddressIcon,
	EmailIcon,
	PhoneIcon,
	SortArrowIcon,
	WebsiteIcon,
} from "../../../common-components/svgIcons";
import { Card, Divider, Pagination } from "@mui/material";
import { NeutralColor, SecondaryColor } from "node-library/dist/colors";

import { GreenTickIcon } from "../../../common-components/toast/successIcons";
import ViewOrderPageSkeletonUI from "../viewOrders/skeletonUI/orderHistoryPageSkeleton";
import { SkyBlueButton } from "../../../common-components/button";

interface Props {
	company: FrontendCompany | undefined;
}

export default function HelpAndContactPage(props: Props) {
	const { t: translation } = useTranslation();
	const { company } = props;

	return (
		<div style={{ margin: "16px 24px 16px" }}>
			<div
				className="typography-heading-01"
				style={{ margin: "60px 0px 20px 0px" }}
			>
				{translation("ContactUsHeader")}
			</div>
			<Card className="card-medium-padding">
				<div
					className="typography-body-01"
					style={{
						borderRadius: "12px",
						backgroundColor: SecondaryColor.SECONDARY_50,
						textAlign: "center",
						padding: "12px 16px",
					}}
				>
					<div>{company?.companyName}</div>
					{company?.hoursOfOperation ? (
						<div>{company.hoursOfOperation}</div>
					) : (
						<></>
					)}
				</div>

				<div className="contact-us-info-section">
					<div className="contact-us-info-header">
						<AddressIcon size={24}></AddressIcon>
						<div className="typography-heading-03">
							{translation("Address")}
						</div>
					</div>
					<div className="typography-body-02">{company?.address}</div>
				</div>
				<Divider orientation="horizontal" flexItem sx={{ my: 1 }}></Divider>
				<div className="contact-us-info-section">
					<div className="contact-us-info-header">
						<PhoneIcon
							size={24}
							fillColor={NeutralColor.NEUTRAL_GREY_900}
						></PhoneIcon>
						<div className="typography-heading-03">{translation("Phone")}</div>
					</div>
					{company?.tollFreeNumber ? (
						<div className="typography-body-02">{`${translation("TollFree")}: ${
							company?.tollFreeNumber
						}`}</div>
					) : (
						<></>
					)}
					<div className="typography-body-02">{`${translation("Tel")}: ${
						company?.phoneNumber
					}`}</div>
					{company?.faxNumber ? (
						<div className="typography-body-02">{`${translation("Fax")}: ${
							company?.faxNumber
						}`}</div>
					) : (
						<></>
					)}
				</div>
				<Divider orientation="horizontal" flexItem sx={{ my: 1 }}></Divider>
				{company?.contactEmail ? (
					<>
						<div className="contact-us-info-section">
							<div className="contact-us-info-header">
								<EmailIcon
									size={24}
									strokeColor="white"
									fillColor={NeutralColor.NEUTRAL_GREY_900}
								></EmailIcon>
								<div className="typography-heading-03">
									{translation("Email")}
								</div>
							</div>
							<div className="typography-body-02">{company?.contactEmail}</div>
						</div>
						<Divider orientation="horizontal" flexItem sx={{ my: 1 }}></Divider>
					</>
				) : (
					<></>
				)}
				{company?.website ? (
					<>
						<div className="contact-us-info-section">
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									flexWrap: "wrap",
								}}
							>
								<div>
									<div className="contact-us-info-header">
										<WebsiteIcon size={24}></WebsiteIcon>
										<div className="typography-heading-03">
											{translation("Website")}
										</div>
									</div>
									<div className="typography-body-02">
										<a
											href={company?.website}
											target="_blank"
											rel="noopener noreferrer"
										>
											{company?.website}
										</a>
									</div>
								</div>
								<SkyBlueButton
									id={"contact-faq-button"}
									onClick={() => {
										window.open(
											"https://ppbanalytical.com/contact/",
											"_blank",
											"noopener noreferrer"
										);
									}}
								>
									{translation("FAQ")}
								</SkyBlueButton>
							</div>
						</div>
					</>
				) : (
					<></>
				)}
			</Card>
			{/* <DiscardOrderConfirmModal
				open={discardOrderConfirmOpen}
				setOpen={setDiscardOrderConfirmOpen}
				proceedAction={proceedAction}
			></DiscardOrderConfirmModal> */}
		</div>
	);
}
